// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";
import { SearchResponse } from "../../types/types.d";

// Define a service using a base URL and expected endpoints
export const globalSearchAPI = createApi({
  reducerPath: "globalSearchAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    searchABO: builder.mutation<SearchResponse, { payload: { keyword: string } }>({
      query: ({ payload }) => ({
        url: `/am/search`,
        method: "POST",
        data: payload,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSearchABOMutation,
} = globalSearchAPI;
